<div class="container-fluid p-3">

  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ proposalName }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">


        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md"
    *ngIf="schemeType == 'idex' && challengesFormData">
    <div (click)="toggleSection('basicInfo')"
      class="flex items-center justify-between p-4 cursor-pointer bg-gray-200 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
      <h3 class="text-lg font-semibold flex items-center">
        <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
          <i class="pi pi-file-edit"></i>
        </span> Challenge Form <span
          class="w-12 p-1 border-2 border-purple-500 ml-5 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
          View </span>
      </h3>
      <i class="pi transition-transform duration-200"
        [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    <div *ngIf="expandedSections['basicInfo']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
      <app-idex-from [stepDetails]="challengesFormData" [challengesData]="challengesFormData"></app-idex-from>
    </div>
  </div>
  <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md"
    *ngIf="schemeType == 'idex' && winnersVendorData">
    <div (click)="toggleSection('vendorTable')"
      class="flex items-center justify-between p-4 cursor-pointer bg-gray-200 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
      <h3 class="text-lg font-semibold flex items-center">
        <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
          <i class="pi pi-users"></i>
        </span> Vendor Table 
      </h3>
      <i class="pi transition-transform duration-200"
        [ngClass]="expandedSections['vendorTable'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    <div *ngIf="expandedSections['vendorTable']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">

    <div class="overflow-x-auto" *ngIf="winnersVendorData.length; else noVendorData">
      <p-table
        [value]="winnersVendorData"
        [columns]="vendorTableColumns"
        [paginator]="false"
        class="min-w-full bg-white border border-gray-200 rounded-md"
        [resizableColumns]="true"
        [showCurrentPageReport]="false"
        [rowHover]="true"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pResizableColumn style="width: 40px">#</th>
            <th
              *ngFor="let col of columns"
              pResizableColumn
              [pSortableColumn]="col.field"
              pFilterMenu
            >
              <span class="flex items-center gap-2">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
              </span>
            </th>
            <th *ngIf="stepDetails.can_edit">
              Actions
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">
          <tr>
            <td class="py-2 px-4 border-b text-center">{{ rowIndex + 1 }}</td>
            <td
              class="py-2 px-4 border-b"
              *ngFor="let col of columns"
            >
              <ng-container [ngSwitch]="col.field">
                <span
                  *ngSwitchCase="'vendor_status'"
                  class="badge"
                  [ngClass]="{
                    'bg-green-100 text-green-700 border border-green-300': row.vendor_status === 'Qualify' || row.vendor_status === 'Qualify',
                    'bg-yellow-100 text-yellow-700 border border-yellow-300': row.vendor_status === 'Pending' || row.vendor_status === 'Initiated',
                    'bg-red-100 text-red-700 border border-red-300': row.vendor_status === 'Rejected' || row.vendor_status === 'Inactive',
                    'bg-blue-100 text-blue-700 border border-blue-300': row.vendor_status === 'Shared',
                    'bg-gray-100 text-gray-700 border border-gray-300': !row.vendor_status
                  }
                  "
                  style="padding:0.35em 0.8em; border-radius: 12px; font-size:0.95em; font-weight:500; display:inline-flex; align-items:center; gap:0.4em"
                >
                  {{ row.vendor_status || 'N/A' }}
                </span>
                <span *ngSwitchCase="'vendor.name'">{{ row.vendor?.name }}</span>
                <span *ngSwitchCase="'vendor.email'">{{ row.vendor?.email }}</span>
                <span *ngSwitchCase="'vendor.contact'">{{ row.vendor?.contact }}</span>
                <span *ngSwitchCase="'document_receive'"
                class="badge border-3"
                [ngClass]="{
                  'bg-green-100 text-green-700 border border-green-300': row.document_receive,
                  'bg-red-100 text-red-700 border border-red-300': !row.document_receive
                }"
                style="padding:0.35em 0.8em; border-radius: 12px; font-size:0.95em; font-weight:500; display:inline-flex; align-items:center; gap:0.4em"
                >
                <span *ngIf="row.document_receive">Received</span>
                <span *ngIf="!row.document_receive">Not Received</span>
                </span>
                <span *ngSwitchDefault>{{ row[col.field] }}</span>
              </ng-container>
            </td>
           <td *ngIf="stepDetails.can_edit">
           <button [disabled]="row.document_receive" class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded transition duration-150" (click)="recivedDocument(row)" >
             Received
           </button>
           </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template #noVendorData>
      <div class="bg-white border border-dashed border-gray-300 rounded-md p-6 text-center text-slate-500">
        No vendor data available.
      </div>
    </ng-template>

    </div>
  </div>
  <!-- <form class="proposal-form-container">
    <div class="form-container">
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('basicInfo')">
          <h3 class="section-title">
            PDS Document
            <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        <div class="section-content" *ngIf="expandedSections['basicInfo']">
          <div class="form-grid">
            <div class="form-field full-width">
              <label for="nomenclature">Nomenclature <span class="required-asterisk">*</span></label>
              <input pInputText id="nomenclature" formControlName="nomenclature" autocomplete="off" />
              <div *ngIf="docuemntList?.pds_file">
                <h5 class="mt-4">
                  PDS Document
                </h5>
                <ul>
                  <li *ngIf="docuemntList.pds_file">
                    <a [href]="baseUrl + docuemntList.pds_file" target="_blank" rel="noopener noreferrer">
                      {{ getFileName(docuemntList.pds_file) }}
                    </a>
                  </li>
                </ul>
              </div>
              <div *ngIf="docuemntList?.pru_file">
                <h5 class="mt-4">
                  PRU Document
                </h5>
                <ul>
                  <li *ngIf="docuemntList.pru_file">
                    <a [href]="baseUrl + docuemntList.pru_file" target="_blank" rel="noopener noreferrer">
                      {{ getFileName(docuemntList.pru_file) }}
                    </a>
                  </li>
                </ul>
              </div>
              <div *ngIf="!docuemntList.pds_file && !docuemntList.pru_file">
                <p class="text-muted">
                  No Files.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('uploads')">
          <h3 class="section-title">
              PDS / PRU Table
            <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        File Uploads Table
        <div class="form-section" *ngIf="expandedSections['uploads']">
          Document Upload Table
            <p-table #table [value]="winners" dataKey="id" editMode="row" [tableStyle]="{'min-width': '70rem'}">
                <ng-template pTemplate="header">
                  <tr>
                    <th>#</th>
                    <th>Applicant</th>
                    <th>Company</th>
                    <th class="text-center" *ngIf="format == 'upload'">PDS Document</th>
                    <th class="text-center" *ngIf="format == 'upload'">PRU Document</th>
                    <th class="text-center" *ngIf="format != 'upload'">Shared on iDEX</th>
                    <th class="text-center" *ngIf="format != 'upload'">Notes</th>
                    <th class="text-center">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
                  <tr [pEditableRow]="row">
                    <td>{{ ri + 1 }}</td>
                    <td>{{ row.vendor.name }}</td>
                    <td>{{ row.vendor.company_name }}</td>
                    <td class="text-center" *ngIf="format == 'upload'">
                      <div *ngIf="!editing">
                        <button pButton class="p-button-rounded p-button-text" pTooltip="Download PDS" [disabled]="!row.pdsFileId"
                          (click)="download(row.pdsFileId, 'PDS.pdf')"></button>
                        <span *ngIf="row.pdsFileId; else noFile">
                          <a [href]="baseUrl + row.pdsFileId" [attr.download]="getFileName(row.pdsFileId)" target="_blank">
                            {{ getFileName(row.pdsFileId) }}
                          </a>
                        </span>
                        <ng-template #noFile>
                          <span class="text-muted">No file</span>
                        </ng-template>
                      </div>
                      <div *ngIf="editing">
                        <p-fileUpload mode="basic" name="pdsFile" [auto]="true" [maxFileSize]="2000000" chooseLabel="Upload PDS"
                          (onSelect)="onFileUpload($event, row, 'pds')"></p-fileUpload>
                        <small *ngIf="row.pds">{{ row.pds.name }}</small>
                      </div>
                    </td>
                    <td class="text-center" *ngIf="format == 'upload'">
                      <div *ngIf="!editing">
                        <button pButton class="p-button-rounded p-button-text" pTooltip="Download PRU" [disabled]="!row.pruFileId"
                          (click)="download(row.pruFileId, 'PRU.pdf')"></button>
                        <span *ngIf="row.pruFileId; else noFile">
                          <a [href]="baseUrl + row.pruFileId" [attr.download]="getFileName(row.pruFileId)" target="_blank">
                            {{ getFileName(row.pruFileId) }}
                          </a>
                        </span>
                        <ng-template #noFile>
                          <span class="text-muted">No file</span>
                        </ng-template>
                      </div>
                      <div *ngIf="editing">
                        <p-fileUpload mode="basic" name="pruFile" [auto]="true" [maxFileSize]="2000000" chooseLabel="Upload PRU"
                          (onSelect)="onFileUpload($event, row, 'pru')"></p-fileUpload>
                        <app-upload-document></app-upload-document>
                        <small *ngIf="row.pru">{{ row.pru.name }}</small>
                      </div>
                    </td>
                    <td *ngIf="format != 'upload'">
                      <div *ngIf="editing">
                        <p-radioButton name="shared{{ ri }}" [value]="true" [(ngModel)]="row.send_idex" inputId="yes{{ ri }}">
                        </p-radioButton>
                        <label for="yes{{ ri }}">Yes</label><br />

                        <p-radioButton name="shared{{ ri }}" [value]="false" [(ngModel)]="row.send_idex" inputId="no{{ ri }}">
                        </p-radioButton>
                        <label for="no{{ ri }}">No</label>
                      </div>

                      <span *ngIf="!editing">
                        {{ row.send_idex ? 'Yes' : 'No' }}
                      </span>
                    </td>

                    <td class="text-center" *ngIf="format != 'upload'">
                      <span *ngIf="!editing">{{ row.remarks || '-' }}</span>
                      <input *ngIf="editing" type="text" pInputText [(ngModel)]="row.remarks" placeholder="Enter notes"
                        class="w-100">
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center gap-2">
                        <button *ngIf="!editing" (click)="table.initRowEdit(row)" class="p-button-warning">Edit</button>

                        <button *ngIf="editing" (click)="saveRow(row, ri, table)" class="fetch-data-btn">Save</button>

                        <button *ngIf="editing" (click)="table.cancelRowEdit(row)" class="p-button-danger">Cancel</button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
            </p-table>
        </div>
      </div>
    </div>
  </form> -->

</div>